import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PaymentComponent } from 'src/app/components/payment/payment.component';


@Component({
    selector: 'payments-dialog',
    template: `
<app-payment [area]="data.area" [accountId]="data.the_accountId" (close)="dialogRef.close($event)"></app-payment>
  `,
    styles: [`
      mat-dialog-container.mat-mdc-dialog-container .dialog.payment [mat-dialog-content] { padding:40px 0 }
      .dialog.payment .mat-button-toggle-appearance-standard .mat-button-toggle-label-content { line-height: 30px; }
  `],
    standalone: true,
    imports: [PaymentComponent],
})
export class PaymentsDialogComponent implements OnInit {
  constructor(public dialogRef: MatDialogRef<PaymentsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    // console.log(dialogRef, dialogRef.id, data)
  }

  ngOnInit() { }
}

